import React from 'react';
const testimonials = [{
  initials: 'MR',
  quote: 'Ho smesso di perdere ore a preparare gli allenamenti. Ora apro Calcio Giovanile Pronto e so esattamente cosa fare.',
  name: 'Marco R.',
  role: 'Allenatore U10'
}, {
  initials: 'AP',
  quote: 'I bambini sono più coinvolti e seguono una progressione molto più chiara.',
  name: 'Andrea P.',
  role: 'Allenatore U12'
}, {
  initials: 'LT',
  quote: "Finalmente ho una stagione completa organizzata dalla prima all'ultima settimana.",
  name: 'Luca T.',
  role: 'Scuola Calcio'
}, {
  initials: 'SF',
  quote: 'Le schede di valutazione hanno cambiato i colloqui con le famiglie. Ora parlo con i numeri.',
  name: 'Stefano F.',
  role: 'Allenatore U14'
}, {
  initials: 'GC',
  quote: "In due mesi il gruppo è cresciuto più che nell'intera scorsa stagione.",
  name: 'Giulia C.',
  role: 'Allenatrice U8'
}, {
  initials: 'DR',
  quote: 'I 300 giochi inclusi nei bonus sono stati la svolta per i miei allenamenti.',
  name: 'Davide R.',
  role: 'Allenatore U6'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-211">
      <div className="max-w-5xl mx-auto" data-id="element-212">
        <div className="text-center mb-12" data-id="element-213">
          <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] mb-3 tracking-tight" data-id="element-214">
            Cosa dicono gli <span className="text-[#16A34A]" data-id="element-215">allenatori</span>
          </h2>
          <p className="text-[#5A5A66] text-base font-bold" data-id="element-216">
            ⭐⭐⭐⭐⭐ 4.9/5 · +1.000 allenatori in tutta Italia
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-217">
          {testimonials.map((t, i) => <div key={i} className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 flex flex-col shadow-sm" data-id="element-218">
              <div className="flex items-center gap-3 mb-4" data-id="element-219">
                <div className="w-10 h-10 rounded-full bg-[#16A34A] flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-220">
                  {t.initials}
                </div>
                <div className="text-[#FFD700] text-sm" data-id="element-221">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-[#0A0A0A] text-sm font-medium italic leading-relaxed mb-6 flex-1" data-id="element-222">
                "{t.quote}"
              </p>
              <div data-id="element-223">
                <p className="text-[#0A0A0A] font-black text-sm" data-id="element-224">{t.name}</p>
                <p className="text-[#5A5A66] text-xs font-semibold mt-0.5" data-id="element-225">
                  {t.role}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}